module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "pubitCssCls1"
  }), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls26"
  }, [_c('span', {
    staticClass: "Apple-style-span sgc-1"
  }), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls28"
  }, [_c('span', {
    staticClass: "pubitCssCls29"
  }, [_vm._v("Acknowlegments")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Thank you to my editor Jennifer Melendrez who corrected the thousand and one punctuation errors and whose suggestions made it a far better book.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Thanks to my wife Emily for making vital suggestions for the book and for tolerating my full-time retired presence while I commandeered a corner of our living room for my portable writing desk.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("Thank you Sunbury Press for publishing my work.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("And last but not least, a salute to all the millions of RVers across the country seeking adventure. I wish you smooth highways and level campsites.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  }), _vm._v(" "), _c('span', {
    staticClass: "pubitCssCls14"
  }), _vm._v(" "), _c('span', {
    staticClass: "pubitCssCls14"
  }), _vm._v(" "), _c('span', {
    staticClass: "pubitCssCls14"
  }, [_vm._v("***********")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls14"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls30"
  }, [_c('span', {
    staticClass: "pubitCssCls31"
  }, [_vm._v("Look for the next Hank and Helen Moran RV adventure. Book two of the RV Mysteries is in progress and will be published in the spring of 2012.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 63
// module chunks = 0